import {
    useTooltipContentStyles,
} from 'app/shared-components/Tooltip'
import useStyles from './TooltipContent.styles'

const TooltipContentCollectionService = () => {
    const {
        classes,
        cx,
    } = useStyles()
    const {
        classes: sharedTooltipClasses,
    } = useTooltipContentStyles()

    return (
        <div className={classes.container}>
            <div className={classes.textContainer}>
                <div className={classes.headerContainer}>
                    <div className={classes.listIndicator} />
                    <span className={sharedTooltipClasses.header}>Collection (SkyCell)</span>
                </div>
                <span className={cx(sharedTooltipClasses.paragraph, classes.paragraph)}>
                    SkyCell collects the container from an external
                    Drop-off location that is defined by the customer.
                    Usually this location is the Consignee.
                </span>
            </div>
            <div className={classes.textContainer}>
                <div className={classes.headerContainer}>
                    <div className={classes.listIndicator} />
                    <span className={sharedTooltipClasses.header}>Drop-off Airport (Customer)</span>
                </div>
                <span className={cx(sharedTooltipClasses.paragraph, classes.paragraph)}>
                    Customer drops the container at an airport
                    facility. Usually this location is a GHA.
                    This option is only used for Airline Leases.
                </span>
            </div>
            <div className={classes.textContainer}>
                <div className={classes.headerContainer}>
                    <div className={classes.listIndicator} />
                    <span className={sharedTooltipClasses.header}>
                        Drop-off Forwarder (Customer)
                    </span>
                </div>
                <span className={cx(sharedTooltipClasses.paragraph, classes.paragraph)}>
                    Customer drops the container at a Forwarder’s facility (SkyCell partner).
                    This option is mainly used for Direct Leases.
                    This option is typically used for cases where SkyCell does not have a
                    Service Center or our Service Center is
                    too far away from the destination airport.
                </span>
            </div>
            <div className={classes.textContainer}>
                <div className={classes.headerContainer}>
                    <div className={classes.listIndicator} />
                    <span className={sharedTooltipClasses.header}>Drop-off SkyCell (Customer)</span>
                </div>
                <span className={cx(sharedTooltipClasses.paragraph, classes.paragraph)}>
                    Customer drops the container at a SkyCell Service Center or Consignment Stock.
                </span>
            </div>
        </div>
    )
}

export default TooltipContentCollectionService
